
const Basvuru = () => {
  return (
    <> 
      <div className="row justify-content-center mb-4 header-hero pt-4 pb-4">
        <div className="col-md-10 col-sm-12">
          <h2>Başvuru</h2>
        </div>
      </div>

      <div className="row justify-content-md-center mb-4">
        <div className="col-md-10 col-sm-12 mt-4">
          <p>POLSAN Teknokent içinde 4691 Sayılı Teknoloji Geliştirme Bölgeleri Yasası ve Yönetmeliği, ilgili diğer yasalar ve yönetmeliklerden faydalanmak üzere yer almak isteyen firma ve girişimciler başvuru ve sonrasındaki tüm işlemleri portal üzerinden gerçekleştirir.</p>
          <p>Başvuru süreci, firmanın sistem üzerinden başvuru formunu doldurması ve gerekli ek belgeleri sisteme yüklemesi ile başlar. Başvuru formunun gönderilmesini takiben, Yönetici Şirket yetkilisi, başvuru formunu ekleriyle birlikte inceler. Yönetici Şirket yetkilisi tespit ettiği eksikleri/düzeltmeleri firmaya iletir ve formda düzeltme yapılmasını ister. Firma kendisine iletilen geri bildirime göre başvuru formunu revize eder ve görüş̧ almak için tekrar Yönetici Şirket’e iletir. Tüm bu inceleme, değerlendirme ve revize işlemleri başvuru formu nihai hale gelene kadar tekrar eder.</p>
        </div>
      </div>

      <div className="row justify-content-md-center mb-4">
        <div className="d-grid col-md-2 col-sm-6 mx-auto">
          <a href="https://basvuru.polsanteknokent.com.tr" className="btn btn-primary btn-lg btn-basvuru" role="button" target="_blank">BAŞVURU</a>
        </div>
      </div>
    </>
  );
};

export default Basvuru;
